import { DOM } from '../shared/helpers/Document';

(() => {
	const form = DOM.id('emailing-subscribe-form');
	if(! form ) {
		return null;
	}
	
	
	form.addEventListener('submit', event => {
		event.preventDefault();
		
		const classes = {
			LOADING: 'is-loading',
			SUCCESS: 'is-success',
			FAIL: 'is-fail',
		};
		
		if( form.classList.contains(classes.LOADING) || form.classList.contains(classes.SUCCESS) ) {
			return;
		}
		
		const data = new FormData(form);
		form.classList.add(classes.LOADING);
		
		const headers = new Headers();
		const csrf = document.querySelector("meta[name='csrf-token']");
		if( csrf ) {
			headers.append('X-CSRF-Token', csrf.getAttribute('content'));
		}

		const url = form.getAttribute('action');
		fetch(url, {
			  method: 'POST',
			  body: data,
			  headers: headers,
			})
			.then(response => response.json())
			.then(json => {

				if(! json.success ) {
					alert(json.message);
					form.classList.remove(classes.LOADING);
					form.classList.add(classes.FAIL);
					return;
				}
				
				form.classList.remove(classes.LOADING);
				form.classList.add(classes.SUCCESS);
				
				setTimeout(() => {
					form.classList.remove(classes.SUCCESS);
					form.reset();
				}, 2500);
			});
	});
	
})();